import { render, staticRenderFns } from "./createTemplatePage copy.vue?vue&type=template&id=ff6729c6&scoped=true"
import script from "./createTemplatePage copy.vue?vue&type=script&lang=js"
export * from "./createTemplatePage copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6729c6",
  null
  
)

export default component.exports